import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.x3r_1 = user;
        this.y3r_1 = authenticated;
        this.z3r_1 = loading;
        this.a3s_1 = error;
        this.b3s_1 = loginWithRedirect;
        this.c3s_1 = getIdTokenClaims;
        this.d3s_1 = logout;
        this.e3s_1 = getAccessTokenSilently;
      }
      xe() {
        return this.y3r_1;
      }
      f3s() {
        return this.z3r_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.x3r_1) + ', authenticated=' + this.y3r_1 + ', loading=' + this.z3r_1 + ', error=' + toString(this.a3s_1) + ', loginWithRedirect=' + toString_0(this.b3s_1) + ', getIdTokenClaims=' + toString_0(this.c3s_1) + ', logout=' + toString_0(this.d3s_1) + ', getAccessTokenSilently=' + toString_0(this.e3s_1) + ')';
      }
      hashCode() {
        var result = this.x3r_1 == null ? 0 : hashCode(this.x3r_1);
        result = imul(result, 31) + getBooleanHashCode(this.y3r_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.z3r_1) | 0;
        result = imul(result, 31) + (this.a3s_1 == null ? 0 : hashCode(this.a3s_1)) | 0;
        result = imul(result, 31) + hashCode(this.b3s_1) | 0;
        result = imul(result, 31) + hashCode(this.c3s_1) | 0;
        result = imul(result, 31) + hashCode(this.d3s_1) | 0;
        result = imul(result, 31) + hashCode(this.e3s_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.x3r_1, other.x3r_1))
          return false;
        if (!(this.y3r_1 === other.y3r_1))
          return false;
        if (!(this.z3r_1 === other.z3r_1))
          return false;
        if (!equals(this.a3s_1, other.a3s_1))
          return false;
        if (!equals(this.b3s_1, other.b3s_1))
          return false;
        if (!equals(this.c3s_1, other.c3s_1))
          return false;
        if (!equals(this.d3s_1, other.d3s_1))
          return false;
        if (!equals(this.e3s_1, other.e3s_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
